import { combineReducers } from "redux";
import SharedReducer from "./Shared/reducer";
import { reducer as toastrReducer } from "react-redux-toastr";

export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    toastr: toastrReducer,
    SharedReducer,
    ...injectedReducers,
  });

  return rootReducer;
}
